module.exports = __webpack_public_path__ + "fonts/VarelaRound-Regular.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/Varela_Round/VarelaRound-Regular.ttf
// module id = 3472
// module chunks = 0